import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { scroller } from 'react-scroll'

// import { articleCardsNew } from '../../consts/articlesCardsNew'
// import { selectionImages } from '../../consts/collectionPage'
// import { weekSelection } from '../../consts/collectionPageData'
// import { menuItems } from '../../consts/menuItems'
// import { collectionsData } from '../../consts/collectionPageData'
// import { selectionCardData } from '../../consts/selectionCardData'
// import {
//   shuffleArray,
//   shuffleArrayExceptLast,
//   shuffleArrayExceptLastTwo,
// } from '../../helpers/randomArray'
// import InvestmentMainBanner from '../InvestmentMainBanner/InvestmentMainBanner'
// import { MainHero } from '../MainHero/MainHero'
// import { NavMenu } from '../NavMenu/NavMenu'
// import { NewAnonceList } from '../NewAnonceList/NewAnonceList'
// import NewCollectionBanner from '../NewCollectionBanner/NewCollectionBanner'
// import { fetchSelectionsRequest } from '../../store/selections/actions'
import { setPageName } from '../../store/page/actions'
import { Feedback } from '../Feedback/Feedback'
import { NewMainHero } from '../NewMainHero/NewMainHero'
import { NewBanner } from '../UI/NewBanner/NewBanner'
import { NewBuildings } from './newBuildings/NewBuildings'
import style from './NewMain2.module.scss'

export const setBodyColor = (color: string) => {
  document.documentElement.style.setProperty('--body-bg', color)
}

const NewMain2: FC = () => {
  const dispatch = useDispatch()
  const { hash } = useLocation()
  const location = useLocation()
  // const collectionData = weekSelection

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        scroller.scrollTo(hash, {
          delay: 0,
        })
        location.hash = ''
      }, 500)
    }
  }, [hash])

  useEffect(() => {
    dispatch(setPageName('main'))
    setBodyColor('#fff')

    // dispatch(
    //   fetchSelectionsRequest(`${collectionData.id}-${collectionData.id}`)
    // )

    return () => {
      setBodyColor('#f7f7f5')
    }
  }, [])

  return (
    <div className={style.NewMainPage}>
      <NewMainHero />
      <NewBanner pageType='main' />
      <Feedback />
      <NewBuildings />

      {/* <NavMenu menuItems={menuItems} /> */}
      {/* <MainHero
        collectionId={collectionData.id}
        btnName='Смотреть подборку недели'
      /> */}
      {/* <NewCollectionBanner
        title={collectionData.anonce?.title}
        lead={collectionData.anonce?.lead}
        id={+collectionData.id}
        img={collectionData.anonce?.imagePath}
        linkLastCard={collectionData.linkLastCard}
        video={collectionData.anonce?.video}
        table={!!collectionData.tables}
        type={collectionData.type}
      /> */}
      {/* <NewAnonceList
        items={shuffleArrayExceptLastTwo(selectionCardData)}
        title='Все подборки'
        category='/collections/'
        id='#selections'
      /> */}
      {/* <InvestmentMainBanner /> */}
      {/* <NewAnonceList
        items={articleCardsNew}
        title='Статьи'
        category='/article/'
        id='#articles'
      /> */}
    </div>
  )
}

export default NewMain2
